import { useState } from 'react';
import { TabItem } from '../types';

export interface TextTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const TextTabs = ({ tabs, activeTab, onTabChange }: TextTabsProps) => {
  const [active, setActive] = useState(() => activeTab);
  return (
    <nav>
      <ul className="flex items-center space-x-3 text-base font-medium">
        {tabs.map((tab) => (
          <li key={tab.id}>
            <button
              type="button"
              onClick={() => {
                setActive(tab.id);
                onTabChange(tab.id);
              }}
              className={`${
                active === tab.id
                  ? 'text-gray-800'
                  : 'text-gray-400 hover:text-gray-500'
              } transition-colors`}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TextTabs;
